<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Importante'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <!-- First -->
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <p class="title-method">Criar Registros do Dia</p>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Data</label>
                      <datepicker v-model="dataFirstImportant.dt" :language="ptBR" :format="customFormatter"
                                  placeholder="Data" required/>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Skip</label>
                      <input v-model="dataFirstImportant.skip" type="text" class="form-control" name="skip"
                             placeholder="Skip">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Take</label>
                      <input v-model="dataFirstImportant.take" type="text" class="form-control" name="take"
                             placeholder="take">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Senha</label>
                      <input v-model="dataFirstImportant.pw" type="text" class="form-control" name="senha"
                             placeholder="Senha">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="execFirst()">
                    <span v-if="!loadingFirst">Executar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              <!-- Second -->
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <p class="title-method">Método 2</p>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Data</label>
                      <datepicker v-model="dataFirstImportant.dt" :language="ptBR" :format="customFormatter"
                                  placeholder="Data" required/>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Skip</label>
                      <input v-model="dataFirstImportant.skip" type="text" class="form-control" name="skip"
                             placeholder="Skip">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Take</label>
                      <input v-model="dataFirstImportant.take" type="text" class="form-control" name="take"
                             placeholder="take">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Senha</label>
                      <input v-model="dataFirstImportant.pw" type="text" class="form-control" name="senha"
                             placeholder="Senha">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="execFirst()">
                    <span v-if="!loadingFirst">Executar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              <!-- Third -->
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <p class="title-method">Método 3</p>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Data</label>
                      <datepicker v-model="dataFirstImportant.dt" :language="ptBR" :format="customFormatter"
                                  placeholder="Data" required/>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Skip</label>
                      <input v-model="dataFirstImportant.skip" type="text" class="form-control" name="skip"
                             placeholder="Skip">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Take</label>
                      <input v-model="dataFirstImportant.take" type="text" class="form-control" name="take"
                             placeholder="take">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Senha</label>
                      <input v-model="dataFirstImportant.pw" type="text" class="form-control" name="senha"
                             placeholder="Senha">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="execFirst()">
                    <span v-if="!loadingFirst">Executar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import swal from 'sweetalert';
import moment from 'moment'

import {
  JOB_CREATE_UPD
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "important",
  components: {
    datepicker,
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      ptBR: ptBR,
      failRequest: false,
      loadingFirst: false,
      dataFirstImportant: {
        dt: '',
        skip: 0,
        take: 9999,
        pw: ''
      },
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    execFirst() {
      if (this.dataFirstImportant.dt && this.dataFirstImportant.pw && this.dataFirstImportant.take && this.dataFirstImportant.skip) {
        moment.locale('pt-br');

        this.loadingFirst = true;
        let url = JOB_CREATE_UPD;
        url += "?pw=" + this.dataFirstImportant.pw;
        url += "&dt=" + moment(this.dataFirstImportant.dt).format("MM-DD-YYYY");
        url += "&skip=" + this.dataFirstImportant.skip;
        url += "&skip=" + this.dataFirstImportant.take;

        UTIL_SERVICE.console("DATA SEND:", url);
        REQUEST_SERVICE.get(url)
          .then((response) => {
            UTIL_SERVICE.console("RESULT JOB_CREATE_UPD:", response.data);

            this.dataPoint = response.data;
            this.loadingFirst = false;
            this.failRequest = false;
          }).catch((reason) => {
          this.loadingFirst = false;
          this.failRequest = true;
          reason.response.data.erros.map((value) => {
            swal("Aviso", value.value, "error");
          });
        });
      } else {
        swal("Aviso", "Preencha os campos para pesquisar", "error");
      }
    }
  }
}
</script>

<style lang="scss">
.vdp-datepicker {
  display: inline-block;
  width: 90%;

  input {
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 34px;
    width: 100%;
    padding: 0 10px;
    cursor: pointer;
  }
}

.title-method {
  font-size: 18px;
  font-weight: 700;
  margin-top: 0;
  border-bottom: 1px solid #e8d7d7;
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/important/important.vue